import { render, staticRenderFns } from "./TrainJourneysPanel.vue?vue&type=template&id=b5a98b22&scoped=true&"
import script from "./TrainJourneysPanel.vue?vue&type=script&lang=js&"
export * from "./TrainJourneysPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a98b22",
  null
  
)

export default component.exports